import { useSelector } from 'react-redux';

import { COMPOSED_CLAIMS } from 'constants/composedClaims';

import { selectIsClaimAllowed } from 'store/auth/selectors';

/**
 * Returns true when the Phone (telephony) member should be available in the bottom-nav
 * Comms group. Mirrors the gating used by `TelephonyHost` / the desktop `Header` phone icon:
 * the telephony claim must be allowed for the company.
 *
 * @returns {boolean}
 */
const usePhoneTabEnabled = () =>
  useSelector(selectIsClaimAllowed(COMPOSED_CLAIMS.TELEPHONY_ENABLED));

export default usePhoneTabEnabled;
